var React = require('react');

function SmLineInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M155.312 1.35778e-05L158.039 5L155.312 10L0 10V0L155.312 1.35778e-05Z","fill":"#E2E6EC","key":0}),React.createElement("path",{"d":"M159.868 1.39761e-05L162.595 5L159.868 10L313 10V2.73633e-05L159.868 1.39761e-05Z","fill":"#E2E6EC","key":1})]);
}

SmLineInline.defaultProps = {"width":"313","height":"10","viewBox":"0 0 313 10","fill":"none"};

module.exports = SmLineInline;

SmLineInline.default = SmLineInline;
